import React, { memo, useState, Fragment } from 'react';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import { makeStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import HomeIcon from '@material-ui/icons/Home';
import AssignmentIcon from '@material-ui/icons/Assignment';
import MobileSidebar from './MobileSidebar';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles(({ palette, spacing }) => ({
	root: {
		position: 'relative',
		minHeight: 70
	},
	fixed: {
		position: 'fixed',
		width: '100%',
		bottom: 0
	},
	flexContainer: {
		color: palette.grey.light[10],
		backgroundColor: palette.grey[900],
		display: 'flex',
		padding: spacing(0, 2)
	},
	bottomNav: {
		flex: 3,
		backgroundColor: palette.grey[900],
		'& span': {
			color: palette.grey.light[10]
		},
		'& svg': {
			fill: palette.grey.light[10]
		}
	},
	active: {
		'& span': {
			color: '#fff !important'
		},
		'& svg': {
			fill: '#fff !important'
		}
	},
	menuButton: {
		flex: 1,
		padding: spacing(0.75, 1.5, 1),
		'&:hover': {
			background: 'transparent'
		},
		'& svg': {
			fill: palette.grey.light[10],
			height: spacing(4.5),
			width: spacing(4.5)
		}
	}
}));

function BottomNav() {
	const classes = useStyles();
	const [ drawerOpen, setDrawerOpen ] = useState(false);

	const tabs = [
		{ label: 'Transactions', icon: <HomeIcon />, route: '/' },
		{ label: 'Budgets', icon: <AssignmentIcon />, route: '/budgets' }
	];

	return (
		<Fragment>
			<MobileSidebar drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
			<div className={classes.root}>
				<div className={classes.fixed}>
					<div className={classes.flexContainer}>
						<IconButton
							disableRipple
							disableFocusRipple
							onClick={() => setDrawerOpen(true)}
							className={classes.menuButton}
							aria-label="menu">
							<MenuIcon />
						</IconButton>
						<BottomNavigation className={classes.bottomNav} showLabels>
							{tabs.map((tab, i) => (
								<BottomNavigationAction
									component={NavLink}
									exact
									activeClassName={classes.active}
									to={tab.route}
									key={i}
									label={tab.label}
									icon={tab.icon}
								/>
							))}
						</BottomNavigation>
					</div>
				</div>
			</div>
		</Fragment>
	);
}

export default memo(BottomNav);
